import { mapState } from 'vuex';
import { vuetifyColors, themesMixin, getContrastYIQ } from '@/utils/themes';

export default {
  mixins: [themesMixin],
  computed: {
    ...mapState('app', ['UiTheme', 'color', 'colorHexLight', 'colorHexDark']),
    customColor() {
      if (/^customerColor(.*?)/gi.exec(this.color)) {
        return this.customColorName;
      }
      return vuetifyColors[this.color];
    },
    customColorName() {
      return this.UiTheme ? this.customColorDark : this.customColorLight;
    },
    customColorDark() {
      return this.colorHexDark || this.colorHexLight;
    },
    customColorLight() {
      return this.colorHexLight || this.colorHexDark;
    },
    customTextColorDark() {
      if (this.customColorDark) {
        return getContrastYIQ(this.customColorDark, '#333333');
      }
      return 'inherit';
    },
    customTextColorLight() {
      if (this.customColorLight) {
        return getContrastYIQ(this.customColorLight, '#333333');
      }
      return 'inherit';
    },
  },
};
